import {SpecialistProfileView} from './SpecialistProfileView';
import { HospitalProfileView } from './HospitalProfileView';
export const SpecialistProfileScreen: React.FC = () => {
  return <SpecialistProfileView />;
};

export const HospitalProfileScreen: React.FC = () => {
  return <HospitalProfileView />;
};